import type { IconProps } from '../types/IconProps.ts';
export const Repeat1: IconProps = {
    name: 'Repeat1',
    children: [
        `<path d="M3 11V9a3 3 0 0 1 3-3h15M21 13v2.04A2.96 2.96 0 0 1 18.04 18H3" />`,
        `<path d="m18 2 2.64 3.01c.5.57.5 1.41 0 1.98L18 10M6 22l-2.64-3.01a1.5 1.5 0 0 1 0-1.98L6 14M10.5 10h1.3q.18.02.2.2V14" />`,
    ]
};